// extracted by mini-css-extract-plugin
export default {"policyContainer":"PrivacyPolicy_policyContainer__AHBnT","lastUpdated":"PrivacyPolicy_lastUpdated__F8KBd"};